import { Form } from "antd";
import { HeaderOverview } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  Wrapper,
  checkDataObject,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardAppSummary } from "service/dashboard/central/overview";
import { SpaceStyle } from "..";

const Summary = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const summaryDate = Form.useWatch("summaryDate");
  const date = findDate(summaryDate, "month");

  const { data, isFetching, isError, error } = useGetDashboardAppSummary({
    property,
    ...date,
  });

  const countSummary = data ? checkDataObject(data) : "0";

  return (
    <Wrapper className="h-[300px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview title={t("summary-of-user")} name="summaryDate" />
        {isError ? (
          <ErrorDashboard error={error} height="200px" />
        ) : (
          <SpaceStyle className="center " direction="vertical">
            <div className="count"style={{fontSize:"36px"}}>{`${countSummary || "0"}`}</div>
            <div className="people"style={{fontSize:"24px"}}>{t("people")}</div>
          </SpaceStyle>
        )}
      </LoadingDashboard>
    </Wrapper>
  );
};

export default Summary;
